export default {
  clear: 'clear',
};
